export default {
  clear: 'clear',
};
